module.exports = __webpack_public_path__ + "static/media/curling.1e920641.svg";